import Home from '@/components/pages/Home'
import AboutUs from '@/components/pages/AboutUs'
import Services from '@/components/pages/Services'
import Testimonials from '@/components/pages/Testimonials'
import ContactUs from '@/components/pages/ContactUs'
import Privacy from '@/components/pages/Privacy'
import Terms from '@/components/pages/Terms'
import EnvironmentalImpact from '@/components/pages/EnvironmentalImpact'

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * NOTE: When adding new routes, due to an issue with the vue-prerender
 * plugin, the routes need to be manually added to build/build.js. In
 * there there is a list of URLs to pre-render on deployment.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/environmental-impact/',
    name: 'EnvironmentalImpact',
    component: EnvironmentalImpact,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/about-us/',
    name: 'AboutUs',
    component: AboutUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/services/',
    name: 'Services',
    component: Services,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/testimonials/',
    name: 'Testimonials',
    component: Testimonials,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'ContactUs',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/privacy-policy/',
    name: 'Privacy',
    component: Privacy,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/terms-and-conditions/',
    name: 'Terms',
    component: Terms,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js